import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'
import ContactsV2 from 'model/facilities/contactsV2'
import enumCollections from 'constants/enumCollections'

const FACILITY_TYPE = 'FacilityProfileV2'

class FacilityProfileV2 extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> FacilityProfileV2 constructor -', init)
    if (isNil(init)) return undefined
    this._isFacility = init.isFacility
    this._confirmed = init.confirmed
    this._confirmed_at = init.confirmed_at
    this._confirmed_by = init.confirmed_by
    this._contacts = new ContactsV2(init.contacts)
    this._distance = init.distance
    this._google_maps_link = init.google_maps_link
    this._latitude = init.latitude
    this._longitude = init.longitude
    this._image_url = init.image_url
    this._internal_notes = init.internal_notes
    this._location_types = init.location_types
    this._display_location_types = init.display_location_types
    this._name = init.name
    this._insurance_tier = init.insurance_tier
    this._source = init.source
    this._uuid = init.uuid
  }

  // Mutations
  static getLocationType(rawType) {
    return (
      enumCollections?.FACILITY_LOCATION_TYPE?.enumValues?.find(
        i => i.name === rawType
      )?.description || rawType
    )
  }

  static shape = {
    confirmed: PropTypes.bool,
    confirmed_at: PropTypes.string,
    confirmed_by: PropTypes.object,
    contacts: PropTypes.instanceOf(ContactsV2),
    distance: PropTypes.string,
    google_maps_link: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    id: PropTypes.string,
    internal_notes: PropTypes.string,
    insurance_tier: PropTypes.object,
    location_types: PropTypes.array,
    name: PropTypes.string,
    source: PropTypes.string,
    uuid: PropTypes.string
  }

  // Getters for class fields
  get confirmed() {
    return this._confirmed
  }

  get confirmed_at() {
    return this._confirmed_at
  }

  get confirmed_by() {
    return this._confirmed_by || {}
  }

  get contacts() {
    return this._contacts || {}
  }

  get distance() {
    return this._distance || ''
  }

  get google_maps_link() {
    return this._google_maps_link
  }

  get latitude() {
    return this._latitude
  }

  get longitude() {
    return this._longitude
  }

  get image_url() {
    return this._image_url
  }

  get internal_notes() {
    return this._internal_notes
  }

  get insurance_tier() {
    return this._insurance_tier
  }

  get location_types() {
    return this._location_types
  }

  get display_location_types() {
    return this._display_location_types
  }

  get name() {
    return this._name || ''
  }

  get source() {
    return this._source || ''
  }

  get uuid() {
    return this._uuid
  }

  // Calculable
  get isFacility() {
    return this._isFacility || this.__typename === FACILITY_TYPE
  }

  get getDisplayName() {
    return this.name
  }
}

export default FacilityProfileV2
